<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  },
  created () {
    this.$store.commit('initUser')
  }
}
</script>

<style>
</style>
